import { HealthcareProviderLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { addressFormatter } from '@dreryk/react-common';
import {
   KeyExtractorRendererKeyExtractor,
   SelectFilterCreator,
   SelectTriggerLabelExtractor,
} from '@dreryk/react-components';

export const healthcareProviderLocationTriggerLabelExtractor: SelectTriggerLabelExtractor<HealthcareProviderLocation> = (
   location
) => location.name;

export const healthcareProviderLocationKeyExtractor: KeyExtractorRendererKeyExtractor<HealthcareProviderLocation> = (
   location
) => location.locationIdentifier.locationId;

export const healthcareProviderLocationSelectFilterCreator: SelectFilterCreator<HealthcareProviderLocation> = ({
   includes,
}) => (location) => {
   return includes(location.name) || includes(addressFormatter(location.address));
};
